module.exports = __webpack_public_path__ + "img/curve-home-bottom.e812c8e6.png";